export default __webpack_public_path__ + "static/media/icon-wifi-tower.d61644c6.svg";